export default __webpack_public_path__ + "static/media/Group1804.341f57ef.svg";